import { render, staticRenderFns } from "./ColisageQCM.vue?vue&type=template&id=e4bae5c2&scoped=true"
import script from "./ColisageQCM.vue?vue&type=script&lang=js"
export * from "./ColisageQCM.vue?vue&type=script&lang=js"
import style0 from "./ColisageQCM.vue?vue&type=style&index=0&id=e4bae5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bae5c2",
  null
  
)

export default component.exports